module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-7",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/97808021495415#_idTextAnchor000"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "Q_F ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Love at first sight is a hypnosis.")])]), _vm._v(" "), _c('p', {
    staticClass: "Q_F ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("—Roland Barthes")])]), _vm._v(" "), _c('p', {
    staticClass: "Epi_F ParaOverride-10"
  }, [_c('span', {
    staticClass: "I _idGenCharOverride-1"
  }, [_vm._v("–")]), _vm._v(" "), _c('span', {
    staticClass: "I _idGenCharOverride-1"
  }, [_vm._v("I don’t believe in love at first sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Epi_L"
  }, [_vm._v("– What do you mean? Wasn’t it clear the moment you picked the elderflowers by the park and we looked at each other? Or was it in that book club?")]), _vm._v(" "), _c('p', {
    staticClass: "TX_Break"
  }, [_vm._v("A few years after we moved in together, we had this conversation about love at first sight. I remember you said:")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘I don’t believe in love at first sight.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I was taken aback. I thought we were definitely in love at first sight.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘What do you mean? Wasn’t it clear the moment you picked the elderflowers by the park and we looked at each other? Or was it in that book club?’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("You gave me a damp smile, as if my confusion proved that you were right.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But doesn’t love always start from first sight? I mean, before one reaches one’s thirties or forties. It’s only when we have a second thought about our first sighted love, that we might change our mind. You might ask, why does this happen before one reaches midlife? I don’t have a theory yet, but I think when we are young, our impulses take over our mind. Romantic love is always an impulse in my case. I am not old or wise enough to understand yet what else love could be.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All I knew in that first moment at the park was that you saw the way I had looked at you. Perhaps I should not be so sure that you saw how I looked at you. Well, you were still a complete stranger. You were from a culture I had no know­ledge or deep understanding of. Besides, you were very tall and I was short. Height sometimes disorients our perspective.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28249ef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97808021495416.vue
// module id = 81
// module chunks = 0